import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { ToastrModule } from 'ngx-toastr';
import { NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { HttpInterceptorService} from './services/http-interceptor.service';
import {IonApp, IonRouterOutlet} from '@ionic/angular/standalone';
import {HeaderComponent} from './helpers/header/header.component';
import {FooterComponent} from './helpers/footer/footer.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    IonRouterOutlet,
    HeaderComponent,
    FooterComponent,
    ToastrModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    ToastrModule.forRoot(), // ToastrModule setup
    NgxMaskDirective
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideEnvironmentNgxMask()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
